import React from 'react';
import { Box, alpha, useTheme } from '@mui/material';

interface PageTitleIconProps {
  /** Icon element (typically the page's sidebar icon) shown inside the badge. */
  icon: React.ReactNode;
  /** Square size in px. */
  size?: number;
}

/**
 * Rounded, brand-tinted square that holds a page's icon next to its title.
 * Used across all page headers for a consistent, professional look.
 */
const PageTitleIcon: React.FC<PageTitleIconProps> = ({ icon, size = 44 }) => {
  const theme = useTheme();
  return (
    <Box
      aria-hidden
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: alpha(theme.palette.primary.main, 0.12),
        color: theme.palette.primary.main,
        '& svg': { fontSize: 24 },
      }}
    >
      {icon}
    </Box>
  );
};

export default PageTitleIcon;
